import React, {useRef, useState} from "react";
import {Button, ButtonContainer, ButtonType, Checkbox, Form, InlineType, Modal, TextAreaInput, ValidationRow} from "@renta-apps/athenaeum-react-components";
import Localizer from "@/localization/Localizer";
import newStyles from "@/pages/NewUI.module.scss";
import ToolsUtility from "@/helpers/ToolsUtility";
import styles from "./SkipInspectionModal.module.scss";

interface SkipInspectionProps {
    onSkipInspection: (comment: string, resetStatus: boolean) => Promise<void>;
    modalRef: React.RefObject<Modal>;
    showResetStatus: boolean;
}

const SkipInspectionModal = (props: SkipInspectionProps) => {

    const formRef = useRef<Form>(null);
    const [comment, setComment] = useState<string | null>(null);
    const [resetStatus, setResetStatus] = useState<boolean>(false);
    
    const _minimumLength = 8;

    const sendSkipAsync = async () : Promise<void> => {
        if (ToolsUtility.isNullOrEmpty(comment)) {
            return;
        }

        await onCloseAsync();
        await props.onSkipInspection(comment!, resetStatus);
    }

    const onCloseAsync = async () => {
        if (props.modalRef.current){
            await props.modalRef.current.closeAsync();
        }
    }

    const setCommentAsync = async (value : string | null): Promise<void> => {
        setComment(value);
    }

    const setResetStatusAsync = async (value : boolean) : Promise<void> => {
        setResetStatus(value);
    }

    const saveDisabled = (): boolean => {
        return ToolsUtility.isNullOrEmpty(comment) || comment!.length < _minimumLength;
    }

    return (
        <Modal id={"skipInspectionModal"}
               ref={props.modalRef}
               title={Localizer.devicePageSkip}
               onClose={onCloseAsync}>

            <Form ref={formRef} id={"skipInspectionForm"} onSubmit={sendSkipAsync}>

                <TextAreaInput required
                               liveValidator={[]}
                               validLength={_minimumLength}
                               id="inspection_comment"
                               rows={4}
                               minLength={3}
                               placeholder={Localizer.devicePageSkipInspectionCommentPlaceholder}
                               value={comment}
                               onChange={async (sender, value) => await setCommentAsync(value)}
                />

                {
                    props.showResetStatus &&
                    <Checkbox inline
                              id={"resetStatus"}
                              inlineType={InlineType.Right}
                              value={resetStatus}
                              label={Localizer.skipInspectionModalResetStatus}
                              onChange={async (sender, value) => await setResetStatusAsync(value)}
                    />
                }

                {
                    resetStatus &&
                    <>
                        <br />
                        <span id="reset-status-text" className={styles.warning}> {Localizer.devicePageSkipWarning} </span>
                        <br />
                    </>
                }

                <br />
                <br />

                <ButtonContainer>

                    <Button submit
                            id={"skip_inspection_modal_confirm_button"}
                            className={newStyles.button}
                            type={ButtonType.Orange}
                            disabled={saveDisabled()}
                            label={Localizer.genericSave}
                    />

                    <Button className={newStyles.button}
                            type={ButtonType.Blue}
                            icon={{name: "far window-close"}}
                            label={Localizer.genericCancel}
                            onClick={async () => await onCloseAsync()}
                    />

                </ButtonContainer>

            </Form>

        </Modal>
    )
}

export default SkipInspectionModal;